export const notificationRoutes = {
  getNotifications: '/api/v1/notification', // pagination Params Eg: ? limit=3 & page=1 & type=shipmentUpdate
  updateNotifications: '/api/v1/notification/read',
  deleteNotification: '/api/v1/notification/:id',
}
